import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import styled from '../../../styles/styled';
import theme from '../../../styles/theme';
const caretBackgroundImage = (active) => {
    const fill = active ? theme.colors.grey90 : theme.colors.grey20;
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20"><path fill="${fill}" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>`;
    return `url('data:image/svg+xml,${encodeURIComponent(svg)}')`;
};
const Select = styled.select `
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    font-size: 1rem;
    font-family: inherit;
    border-color: ${theme.colors.grey20};
    border-width: 1px;
    padding: 0.5rem 1rem 0.5rem 0.5rem;
    width: calc(85px + 1rem);
    line-height: 1.3;
    max-width: 100%;
    margin: 0;
    color: ${theme.colors.grey90};
    background-color: ${theme.colors.white};
    background-image: ${caretBackgroundImage()};
    background-repeat: no-repeat;
    background-position: right 0.5rem top 0.5rem;
    background-size: 20px 20px;
    &:hover,
    &:active {
        border-color: ${theme.colors.grey90};
        background-image: ${caretBackgroundImage(true)};
    }
`;
export const SimpleSelect = ({ options, as, ...props }) => {
    return (_jsx(Select, { ...props, children: options.map((opt, index) => (_jsx("option", { value: opt.value.toString(), "data-testid": `user-list-status-select-${opt.label.toLowerCase()}`, children: opt.label }, index))) }));
};
//# sourceMappingURL=simple_select.js.map